import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const LeadRequestModal = ({ onClose, onCreate }) => {
  const [regions, setRegions] = useState([]);
  const [form, setForm] = useState({ target_name: '', target_email: '', region: 'default', message_draft: '', notes: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${BACKEND_URL}/api/admin/leads/regions`, { withCredentials: true })
      .then((res) => setRegions(res.data.regions || [])).catch(() => {});
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.target_name.trim() || !form.target_email.trim() || !form.message_draft.trim() || saving) return;
    setSaving(true);
    const payload = {
      target_name: form.target_name.trim(),
      target_email: form.target_email.trim(),
      region: form.region,
      message_draft: form.message_draft.trim(),
      notes: form.notes.trim() || undefined,
    };
    const ok = await onCreate(payload);
    setSaving(false);
    if (ok) onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4" data-testid="lead-request-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5 space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-semibold text-slate-900">Request New Lead</h3>
          <button type="button" onClick={onClose} data-testid="lead-request-modal-close">
            <X className="w-5 h-5 text-slate-400 hover:text-slate-700" />
          </button>
        </div>
        <p className="text-xs text-slate-400">Your Manager or Admin will review this and create the lead if approved.</p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <div>
            <label className="text-sm font-medium text-slate-600 block mb-1">Name</label>
            <input
              value={form.target_name}
              onChange={(e) => setForm((f) => ({ ...f, target_name: e.target.value }))}
              data-testid="lead-request-name-input"
              className="w-full border-2 border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600 block mb-1">Email</label>
            <input
              type="email"
              value={form.target_email}
              onChange={(e) => setForm((f) => ({ ...f, target_email: e.target.value }))}
              data-testid="lead-request-email-input"
              className="w-full border-2 border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600 block mb-1">Region</label>
            <select
              value={form.region}
              onChange={(e) => setForm((f) => ({ ...f, region: e.target.value }))}
              data-testid="lead-request-region-select"
              className="w-full border-2 border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
            >
              {regions.map((r) => <option key={r.code} value={r.code}>{r.name}</option>)}
            </select>
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600 block mb-1">First message draft</label>
            <textarea
              value={form.message_draft}
              onChange={(e) => setForm((f) => ({ ...f, message_draft: e.target.value }))}
              rows={4}
              data-testid="lead-request-message-input"
              className="w-full border-2 border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900 resize-none"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-600 block mb-1">Notes for the reviewer (optional)</label>
            <input
              value={form.notes}
              onChange={(e) => setForm((f) => ({ ...f, notes: e.target.value }))}
              data-testid="lead-request-notes-input"
              className="w-full border-2 border-slate-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-900"
            />
          </div>
          <button
            type="submit"
            disabled={saving || !form.target_name.trim() || !form.target_email.trim() || !form.message_draft.trim()}
            data-testid="lead-request-submit-button"
            className="w-full bg-slate-900 text-white py-2.5 rounded-lg font-medium text-sm hover:bg-slate-800 disabled:opacity-50 transition-colors"
          >
            {saving ? 'Submitting…' : 'Submit Request'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LeadRequestModal;
